export default __webpack_public_path__ + "static/media/img--interiors-7.95abcaa6.jpg";